import { useContext as s } from "react";
const u = (t) => Object.entries(t).filter(([r, e]) => e !== void 0).reduce(
  (r, [e, o]) => ({
    ...r,
    [e]: o
  }),
  {}
), c = (...t) => t.map(s).reduce(
  (e, o) => ({ ...e, ...u(o) }),
  {}
);
export {
  c as u
};
//# sourceMappingURL=use-merged-contexts-B9BYBfk1.js.map
